import { configure } from 'react-hotkeys';

configure({
    ignoreRepeatedEventsWhenKeyHeldDown: false,
});
